import { useState, useRef, useEffect } from "react";
import {
  inventoryCategoryOptions,
  inventoryDataStruct,
  inventoryInfoStruct,
  selectedOptic,
  userData,
  inputOnEnter,
} from "../js/utils";
import ButtonIconH from "./ButtonIconH";
import DataTable from "react-data-table-component";
import InputData from "./InputData";
import {
  columnsInventory,
  columnsInventoryCheck,
  columnsInventoryNotFound,
} from "../js/tableColumns";
import { post } from "../js/post";
import "../css/Inventory.css";
import moment from "moment";

const conditionalRowStylesInventory = [
  {
    when: (row) => (row.stockInventario ?? 0) !== (row.stockOPTIWIN ?? 0),
    style: { backgroundColor: "#ffdfbb" },
  },
];

function mergeRegisteredProducts(prev, registered) {
  const registeredMap = new Map(registered.map((p) => [p.codigo, p]));
  const updated = prev.productos.map((p) =>
    registeredMap.has(p.codigo) ? registeredMap.get(p.codigo) : p,
  );
  for (const product of registered) {
    if (!prev.productos.some((p) => p.codigo === product.codigo)) {
      updated.push(product);
    }
  }
  return { ...prev, productos: updated };
}

export function Inventory({
  createPopupQuestion,
  removePopupQuestion,
  onClose,
}) {
  const [selectedOption, setSelectedOption] = useState(
    inventoryCategoryOptions,
  );
  const [isDownloading, setIsDownloading] = useState(false);
  const [manualDownload, setManualDownload] = useState(false);
  const [manualStock, setManualStock] = useState(1);
  const manualCodeRef = useRef("");
  const textareaRef = useRef(null);
  const debounceRef = useRef(null);
  const stockDebouncersRef = useRef({});
  const [inventoryData, setInventoryData] = useState(inventoryDataStruct);
  const inventoryDataRef = useRef(inventoryData);
  inventoryDataRef.current = inventoryData;
  const [inventoryInfo, setInventoryInfo] = useState(inventoryInfoStruct);
  const [verifiedInventoryData, setVerifiedInventoryData] = useState({
    productosLeidos: [],
    productosNoLeidos: [],
    productosNoEncontrados: [],
  });
  const [verificationView, setVerificationView] = useState(false);
  const [expandedTable, setExpandedTable] = useState(null);

  // console.log("selectedOption: ", selectedOption);
  // console.log("inventoryData: ", inventoryData);
  // console.log("verifiedInventoryData: ", verifiedInventoryData);

  async function listInventories() {
    const response = await post(
      "support-extra/inventario/ListarInventarios.php",
      {
        token: userData.token,
        optica: selectedOptic.id,
      },
    );
    setInventoryInfo(response);
  }

  async function verifyInventory() {
    const response = await post(
      "support-extra/inventario/VerificarInventario.php",
      {
        token: userData.token,
        idInventario: inventoryData.idInventario,
      },
    );
    // console.log(
    // "VERIFICANDO INVENTARIO: ",
    // {
    // token: userData.token,
    // idInventario: inventoryData.idInventario,
    // },
    // response,
    // );
    setVerifiedInventoryData(response);
  }

  async function correctProductWarehouse(prods) {
    await post("support-extra/inventario/CorregirAlmacenProductos.php", {
      token: userData.token,
      idInventario: inventoryData.idInventario,
      productos: prods,
    });
    // console.log("CORRIGIENDO ALMACÉN: ", {
    // token: userData.token,
    // idInventario: inventoryData.idInventario,
    // productos: prods,
    // });
  }

  async function clearInventory(idInventario) {
    await post("support-extra/inventario/LimpiarInventario.php", {
      token: userData.token,
      idInventario,
      idAgente: userData.id,
    });
    // console.log("LIMPIANDO INVENTARIO: ", {
    // token: userData.token,
    // idInventario,
    // idAgente: userData.id,
    // });
    setInventoryData((prev) => ({
      ...prev,
      productos: [],
    }));
  }

  async function registerInventoryProducts(idInventario, productos) {
    const response = await post(
      "support-extra/inventario/RegistrarProductosInventario.php",
      {
        token: userData.token,
        idInventario,
        idAgente: userData.id,
        productos,
      },
    );
    // console.log(
    // "REGISTRANDO PRODUCTOS EN INVENTARIO: ",
    // { token: userData.token, idInventario, idAgente: userData.id, productos },
    // response,
    // );
    return response;
  }

  async function loadInventory(famId) {
    const response = await post(
      "support-extra/inventario/CargarInventario.php",
      {
        token: userData.token,
        optica: selectedOptic.id,
        familia: famId,
      },
    );
    // console.log(
    // "CARGANDO INVENTARIO: ",
    // {
    // token: userData.token,
    // optica: selectedOptic.id,
    // familia: famId,
    // },
    // response,
    // );
    setInventoryData(response);
  }

  async function updateProductInventory(prod) {
    await post("support-extra/inventario/ActualizarInventarioProducto.php", {
      token: userData.token,
      idInventario: inventoryData.idInventario,
      idInventarioProducto: prod.idInventarioProducto,
      codigo: prod.codigo,
      stock: prod.stockInventario,
    });
    // console.log("ACTUALIZANDO INVENTARIO PRODUCTO: ", {
    // token: userData.token,
    // idInventario: inventoryData.idInventario,
    // idInventarioProducto: prod.idInventarioProducto,
    // codigo: prod.codigo,
    // stock: prod.stockInventario,
    // });
  }

  async function searchProduct(inputCode) {
    const response = await post("BuscarProducto.php", {
      token: userData.token,
      input: inputCode,
    });
    // console.log(
    // "BUSCANDO PRODUCTO: ",
    // {
    // token: userData.token,
    // input: inputCode,
    // },
    // response,
    // );
    return response;
  }

  function handleManualStock(e) {
    setManualStock(Math.max(1, parseInt(e.target.value) || 1));
  }

  function handleManualCodeChange(e) {
    manualCodeRef.current = e.target.value;
  }

  async function registerManualProduct() {
    const inputCode = manualCodeRef.current.trim();
    if (!inputCode) return;
    const product = await searchProduct(inputCode);
    const codigo = product?.codigoOPTIWIN;
    if (!codigo) {
      createPopupQuestion(
        `No se ha encontrado ningún producto.`,
        () => {
          removePopupQuestion();
          setTimeout(
            () => document.getElementById("manualCodeInput")?.focus(),
            0,
          );
        },
        null,
        "Aceptar",
      );
      return;
    }
    const registered = await registerInventoryProducts(
      inventoryDataRef.current.idInventario,
      [{ codigo, unidades: manualStock }],
    );
    setInventoryData((prev) => mergeRegisteredProducts(prev, registered));
    manualCodeRef.current = "";
    document.getElementById("manualCodeInput").value = "";
    setManualStock(1);
    await listInventories();
  }

  function injectStockInputs(columns, listKey) {
    const baseInventario = listKey === "productosLeidos" ? 100 : 300;
    return columns.map((col) => {
      if (col.id === "inventory-stock") {
        const updateInventory = (codigo, val) =>
          setVerifiedInventoryData((prev) => ({
            ...prev,
            [listKey]: prev[listKey].map((p) =>
              p.codigo === codigo ? { ...p, stockInventario: val } : p,
            ),
          }));
        const incDec = (row, delta) => {
          let newVal;
          setVerifiedInventoryData((prev) => {
            const current = prev[listKey].find((p) => p.codigo === row.codigo);
            newVal = Math.max(0, (current?.stockInventario ?? 0) + delta);
            return {
              ...prev,
              [listKey]: prev[listKey].map((p) =>
                p.codigo === row.codigo ? { ...p, stockInventario: newVal } : p,
              ),
            };
          });
          const key = `${listKey}_${row.codigo}`;
          clearTimeout(stockDebouncersRef.current[key]);
          stockDebouncersRef.current[key] = setTimeout(() => {
            updateProductInventory({ ...row, stockInventario: newVal });
          }, 300);
        };
        return {
          ...col,
          cell: (row, rowIndex) => (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
                alignItems: "center",
              }}
            >
              <button className="incdec-btn" onClick={() => incDec(row, -1)}>
                -
              </button>
              <div style={{ flex: 1 }}>
                <InputData
                  size={0}
                  type="type-integer"
                  tabIndex={baseInventario + rowIndex}
                  input={row.stockInventario ?? 0}
                  onChange={(val) => {
                    const n = parseInt(val);
                    if (!isNaN(n)) updateInventory(row.codigo, n);
                  }}
                  onBlur={(val) => {
                    const n = parseInt(val);
                    if (!isNaN(n))
                      updateProductInventory({ ...row, stockInventario: n });
                  }}
                />
              </div>
              <button className="incdec-btn" onClick={() => incDec(row, +1)}>
                +
              </button>
            </div>
          ),
        };
      }
      if (col.id === "opt-stock") {
        const baseOptiwin = listKey === "productosLeidos" ? 200 : 400;
        const updateOptiwin = (codigo, val) =>
          setVerifiedInventoryData((prev) => ({
            ...prev,
            [listKey]: prev[listKey].map((p) =>
              p.codigo === codigo ? { ...p, stockOPTIWIN: val } : p,
            ),
          }));
        const incDecOptiwin = (row, delta) => {
          let newVal;
          setVerifiedInventoryData((prev) => {
            const current = prev[listKey].find((p) => p.codigo === row.codigo);
            newVal = Math.max(0, (current?.stockOPTIWIN ?? 0) + delta);
            return {
              ...prev,
              [listKey]: prev[listKey].map((p) =>
                p.codigo === row.codigo ? { ...p, stockOPTIWIN: newVal } : p,
              ),
            };
          });
        };
        return {
          ...col,
          cell: (row, rowIndex) => (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
                alignItems: "center",
              }}
            >
              <button
                className="incdec-btn"
                onClick={() => incDecOptiwin(row, -1)}
              >
                -
              </button>
              <div style={{ flex: 1 }}>
                <InputData
                  size={0}
                  type="type-integer"
                  tabIndex={baseOptiwin + rowIndex}
                  input={row.stockOPTIWIN ?? 0}
                  onChange={(val) => {
                    const n = parseInt(val);
                    if (!isNaN(n)) updateOptiwin(row.codigo, n);
                  }}
                />
              </div>
              <button
                className="incdec-btn"
                onClick={() => incDecOptiwin(row, +1)}
              >
                +
              </button>
            </div>
          ),
        };
      }
      return col;
    });
  }

  useEffect(() => {
    if (isDownloading) {
      textareaRef.current?.focus();
    }
    return () => clearTimeout(debounceRef.current);
  }, [isDownloading]);

  useEffect(() => {
    if (manualDownload) {
      document.getElementById("manualCodeInput")?.focus();
    }
  }, [manualDownload]);

  useEffect(() => {
    listInventories();
  }, []);

  const hasSelectedFamily = Object.values(selectedOption).some(Boolean);

  useEffect(() => {
    if (!hasSelectedFamily) {
      setInventoryData(inventoryDataStruct);
    }
  }, [selectedOption]);

  function handleActiveOption(key) {
    setSelectedOption((prev) =>
      Object.keys(prev).reduce((acc, curr) => {
        acc[curr] = curr === key ? !prev[key] : false;
        return acc;
      }, {}),
    );
  }

  function handleScanInput(e) {
    clearTimeout(debounceRef.current);
    const value = e.target.value;
    debounceRef.current = setTimeout(async () => {
      const codes = value
        .split(/\r?\n/)
        .map((c) => c.trim())
        .filter(Boolean);
      const counts = {};
      for (const code of codes) {
        counts[code] = (counts[code] || 0) + 1;
      }
      const scannedProducts = Object.entries(counts).map(
        ([codigo, unidades]) => ({
          codigo,
          unidades,
        }),
      );
      const registered = await registerInventoryProducts(
        inventoryDataRef.current.idInventario,
        scannedProducts,
      );
      setInventoryData((prev) => mergeRegisteredProducts(prev, registered));
      await listInventories();
      setIsDownloading(false);
    }, 800);
  }

  return (
    <div className="popup-container">
      <div className="ap-container popup-screen" style={{ width: "90%" }}>
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Inventario</span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="container-panel"
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <div
              className="thin-rounded-border"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: 18,
              }}
            >
              {[
                { key: "audifonos", text: "Audífonos", infoIndex: 0 },
                { key: "lentes", text: "Lentes", infoIndex: 1 },
                { key: "lc", text: "LC", infoIndex: 2 },
                { key: "liquidos", text: "Líquidos", infoIndex: 3 },
                { key: "monturas", text: "Monturas", infoIndex: 4 },
                { key: "varios", text: "Varios", infoIndex: 5 },
                { key: "sol", text: "Sol", infoIndex: 6 },
              ].map(({ key, text, infoIndex }) => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  <ButtonIconH
                    text={text}
                    selected={selectedOption[key]}
                    disabled={
                      (isDownloading || manualDownload || verificationView) &&
                      !selectedOption[key]
                    }
                    onClick={async () => {
                      await loadInventory(infoIndex);
                      if (
                        !isDownloading &&
                        !manualDownload &&
                        !verificationView
                      )
                        handleActiveOption(key);
                    }}
                  />
                  {inventoryInfo[infoIndex].fecha !== "" && (
                    <span className="cell-label" style={{ color: "#424242" }}>
                      {"Inventario: " +
                        moment(inventoryInfo[infoIndex].fecha).format(
                          "DD/MM/YYYY",
                        )}
                    </span>
                  )}
                </div>
              ))}
            </div>
            {isDownloading ? (
              <div
                className="thin-rounded-border"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  padding: 10,
                }}
              >
                <span>Leyendo códigos de barras...</span>
                <ButtonIconH
                  text="Cancelar descarga"
                  onClick={() => {
                    clearTimeout(debounceRef.current);
                    setIsDownloading(false);
                  }}
                />
                <textarea
                  ref={textareaRef}
                  onChange={handleScanInput}
                  onBlur={() => {
                    if (isDownloading)
                      setTimeout(() => textareaRef.current?.focus(), 10);
                  }}
                  style={{
                    position: "absolute",
                    opacity: 0,
                    width: 1,
                    height: 1,
                    pointerEvents: "none",
                  }}
                />
              </div>
            ) : manualDownload ? (
              <div className="thin-rounded-border">
                <div
                  className="code-reading-container-input"
                  style={{ justifyContent: "center" }}
                >
                  <div className="cell cell-label cell-extra">Stock</div>
                  <div className="input-data input-small">
                    <input
                      type="number"
                      value={manualStock}
                      onChange={handleManualStock}
                      tabIndex={50}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                  <div className="cell cell-label cell-extra">Código</div>
                  <div className="input-data input-medium">
                    <input
                      id="manualCodeInput"
                      tabIndex={51}
                      type="type-alphanum-ext"
                      onChange={handleManualCodeChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && manualCodeRef.current !== "")
                          registerManualProduct();
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                    <img
                      src="/images/search-blue.svg"
                      loading="lazy"
                      alt="Panel icon"
                      className="vectors-wrapper-11"
                    ></img>
                  </div>
                  <ButtonIconH
                    text="Cancelar"
                    onClick={() => {
                      setManualDownload(false);
                    }}
                  />
                </div>
              </div>
            ) : !verificationView ? (
              <div
                className="thin-rounded-border"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  padding: 10,
                }}
              >
                <ButtonIconH
                  disabled={!hasSelectedFamily}
                  text="Iniciar descarga manual"
                  onClick={() => setManualDownload(true)}
                />
                <ButtonIconH
                  disabled={!hasSelectedFamily}
                  text="Iniciar descarga en lote"
                  onClick={() => setIsDownloading(true)}
                />
              </div>
            ) : null}
            {inventoryData.productos.length > 0 &&
              !verificationView &&
              hasSelectedFamily && (
                <>
                  <div
                    className="thin-rounded-border"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: 10,
                    }}
                  >
                    <div className="opt-table-title">{`Productos leídos (${inventoryData.productos.length}) / Stock total (${inventoryData.productos.reduce((acc, p) => acc + p.stockInventario, 0)})`}</div>
                    <DataTable
                      columns={columnsInventory}
                      data={inventoryData.productos}
                      className="custom-datatable inventory-prods-table"
                      noDataComponent="No hay productos disponibles."
                      onRowClicked={() => {}}
                    />
                  </div>
                  <div
                    className="popup-buttons"
                    style={{ justifyContent: "center" }}
                  >
                    <ButtonIconH
                      text="Limpiar"
                      onClick={() => {
                        createPopupQuestion(
                          "Se eliminarán todos los productos leídos. ¿Desea continuar?",
                          async () => {
                            await clearInventory(inventoryData.idInventario);
                            await listInventories();
                            removePopupQuestion();
                          },
                          removePopupQuestion,
                          "Sí",
                          "No",
                        );
                      }}
                    />
                    <ButtonIconH
                      text="Verificar inventario"
                      onClick={async () => {
                        await verifyInventory();
                        setVerificationView(true);
                        setManualDownload(false);
                        setIsDownloading(false);
                        setExpandedTable(null);
                      }}
                    />
                  </div>
                </>
              )}
            {verificationView && (
              <>
                <div
                  className="thin-rounded-border"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 10,
                  }}
                >
                  <div className="opt-table-title opt-table-title-button">
                    {`Verificación de productos leídos (${verifiedInventoryData.productosLeidos.length})`}
                    <div style={{ display: "flex", gap: 6 }}>
                      <ButtonIconH
                        text={
                          expandedTable === "leidos" ? "Contraer" : "Expandir"
                        }
                        small={true}
                        onClick={() =>
                          setExpandedTable(
                            expandedTable === "leidos" ? null : "leidos",
                          )
                        }
                      />
                      <ButtonIconH
                        text="Corregir almacén"
                        highlight={true}
                        disabled={
                          verifiedInventoryData.productosLeidos.length === 0
                        }
                        small={true}
                        onClick={() => {
                          createPopupQuestion(
                            "El stock de OPTIWIN pasará a ser el stock de inventario. ¿Desea continuar?",
                            async () => {
                              const prods =
                                verifiedInventoryData.productosLeidos.map(
                                  (e) => ({
                                    idInventarioProducto:
                                      e.idInventarioProducto,
                                    codigo: e.codigo,
                                    stockInventario: e.stockInventario,
                                  }),
                                );
                              await correctProductWarehouse(prods);
                              createPopupQuestion(
                                `Almacén corregido.`,
                                () => { removePopupQuestion(); },
                                null,
                                "Aceptar",
                              );
                            },
                            removePopupQuestion,
                            "Sí",
                            "No",
                          );
                        }}
                      />
                    </div>
                  </div>
                  {expandedTable !== "noLeidos" &&
                    expandedTable !== "noEncontrados" && (
                      <DataTable
                        columns={injectStockInputs(
                          columnsInventoryCheck,
                          "productosLeidos",
                        )}
                        data={verifiedInventoryData.productosLeidos}
                        className={`custom-datatable ${expandedTable === "leidos" ? "inventory-prods-table-verify--expanded" : "inventory-prods-table-verify"}`}
                        noDataComponent="No hay productos disponibles."
                        conditionalRowStyles={conditionalRowStylesInventory}
                        onRowClicked={() => {}}
                      />
                    )}
                </div>
                <div
                  className="thin-rounded-border"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 10,
                  }}
                >
                  <div className="opt-table-title opt-table-title-button">
                    {`Verificación de productos no leídos (${verifiedInventoryData.productosNoLeidos.length})`}
                    <div style={{ display: "flex", gap: 6 }}>
                      <ButtonIconH
                        text={
                          expandedTable === "noLeidos" ? "Contraer" : "Expandir"
                        }
                        small={true}
                        onClick={() =>
                          setExpandedTable(
                            expandedTable === "noLeidos" ? null : "noLeidos",
                          )
                        }
                      />
                      <ButtonIconH
                        text="Corregir almacén"
                        highlight={true}
                        small={true}
                        disabled={
                          verifiedInventoryData.productosNoLeidos.length === 0
                        }
                        onClick={() => {
                          createPopupQuestion(
                            "El stock de OPTIWIN pasará a ser el stock de inventario. ¿Desea continuar?",
                            async () => {
                              const prods =
                                verifiedInventoryData.productosNoLeidos.map(
                                  (e) => ({
                                    idInventarioProducto:
                                      e.idInventarioProducto,
                                    codigo: e.codigo,
                                    stockInventario: e.stockInventario,
                                  }),
                                );
                              await correctProductWarehouse(prods);
                              createPopupQuestion(
                                `Almacén corregido.`,
                                () => { removePopupQuestion(); },
                                null,
                                "Aceptar",
                              );
                            },
                            removePopupQuestion,
                            "Sí",
                            "No",
                          );
                        }}
                      />
                    </div>
                  </div>
                  {expandedTable !== "leidos" &&
                    expandedTable !== "noEncontrados" && (
                      <DataTable
                        columns={injectStockInputs(
                          columnsInventoryCheck,
                          "productosNoLeidos",
                        )}
                        data={verifiedInventoryData.productosNoLeidos}
                        className={`custom-datatable ${expandedTable === "noLeidos" ? "inventory-prods-table-verify--expanded" : "inventory-prods-table-verify"}`}
                        noDataComponent="No hay productos disponibles."
                        conditionalRowStyles={conditionalRowStylesInventory}
                        onRowClicked={() => {}}
                      />
                    )}
                </div>
                <div
                  className="thin-rounded-border"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 10,
                  }}
                >
                  <div className="opt-table-title opt-table-title-button">
                    {`Verificación de productos no encontrados (${verifiedInventoryData.productosNoEncontrados.length})`}
                    <ButtonIconH
                      text={
                        expandedTable === "noEncontrados"
                          ? "Contraer"
                          : "Expandir"
                      }
                      small={true}
                      onClick={() =>
                        setExpandedTable(
                          expandedTable === "noEncontrados"
                            ? null
                            : "noEncontrados",
                        )
                      }
                    />
                  </div>
                  {expandedTable !== "leidos" &&
                    expandedTable !== "noLeidos" && (
                      <DataTable
                        columns={columnsInventoryNotFound}
                        data={verifiedInventoryData.productosNoEncontrados}
                        className={`custom-datatable ${expandedTable === "noEncontrados" ? "inventory-prods-table-not-found--expanded" : "inventory-prods-table-not-found"}`}
                        noDataComponent="No hay productos disponibles."
                        conditionalRowStyles={conditionalRowStylesInventory}
                        onRowClicked={() => {}}
                      />
                    )}
                </div>
                <div
                  className="popup-buttons"
                  style={{ justifyContent: "center" }}
                >
                  <ButtonIconH
                    text="Volver"
                    onClick={async () => {
                      setVerificationView(false);
                      setExpandedTable(null);
                      setVerifiedInventoryData({
                        productosLeidos: [],
                        productosNoLeidos: [],
                        productosNoEncontrados: [],
                      });
                      const famKeys = [
                        "audifonos",
                        "lentes",
                        "lc",
                        "liquidos",
                        "monturas",
                        "varios",
                        "sol",
                      ];
                      const famId = famKeys.findIndex((k) => selectedOption[k]);
                      if (famId !== -1) await loadInventory(famId);
                    }}
                  ></ButtonIconH>
                  <ButtonIconH text="Imprimir" onClick={() => {}}></ButtonIconH>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
